import { render, staticRenderFns } from "./NoDiagrams.vue?vue&type=template&id=3142475c"
import script from "./NoDiagrams.vue?vue&type=script&lang=ts"
export * from "./NoDiagrams.vue?vue&type=script&lang=ts"
import style0 from "./NoDiagrams.vue?vue&type=style&index=0&id=3142475c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports